class ContentCardsNoImage {
    constructor(element) {
        this.element = element;
        this.swiper = null;
        this.isInitialized = false;
        this.handleResize = this.handleResize.bind(this);
    }

    init() {
        this.initializeSwiper();
        // Listen for resize events to handle responsive behavior
        window.addEventListener('resize', this.handleResize);
    }

    destroy() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
        }
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        const isMobile = window.innerWidth <= 768;
        if (isMobile && !this.isInitialized) {
            this.initializeSwiper();
        } else if (!isMobile && this.isInitialized) {
            this.destroySwiper();
        }
    }

    initializeSwiper() {
        // Only initialize on mobile devices
        if (window.innerWidth > 768) return;

        // Wait for Swiper to be available
        if (typeof Swiper === 'undefined') {
            setTimeout(() => this.initializeSwiper(), 100);
            return;
        }

        const slider = this.element.querySelector('.as-seen-on-grid');
        if (!slider || this.isInitialized) return;

        // Add Swiper wrapper and slide classes
        slider.classList.add('swiper');
        
        // Create wrapper div
        const wrapper = document.createElement('div');
        wrapper.classList.add('swiper-wrapper');
        
        // Move all cards into the wrapper and add swiper-slide class
        const cards = slider.querySelectorAll('.as-seen-on-item');
        cards.forEach(card => {
            card.classList.add('swiper-slide');
            wrapper.appendChild(card);
        });
        
        // Clear the slider and add the wrapper
        slider.innerHTML = '';
        slider.appendChild(wrapper);

        // Add pagination container if it doesn't exist
        let paginationContainer = this.element.querySelector('.as-seen-on-pagination');
        if (!paginationContainer) {
            paginationContainer = document.createElement('div');
            paginationContainer.classList.add('as-seen-on-pagination');
            slider.parentNode.appendChild(paginationContainer);
        }

        // Initialize Swiper
        this.swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: false,
            loop: false,
            pagination: {
                el: '.as-seen-on-pagination',
                clickable: true,
                type: 'bullets',
            },
            breakpoints: {
                480: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
            },
            speed: 300,
            grabCursor: true,
            watchOverflow: true,
        });

        this.isInitialized = true;
    }

    destroySwiper() {
        if (this.swiper) {
            // Get the cards before destroying
            const cards = this.element.querySelectorAll('.as-seen-on-item');
            const slider = this.element.querySelector('.as-seen-on-grid');
            
            // Destroy swiper
            this.swiper.destroy(true, true);
            this.swiper = null;
            
            // Remove swiper classes
            slider.classList.remove('swiper');
            
            // Remove wrapper and restore original structure
            slider.innerHTML = '';
            cards.forEach(card => {
                card.classList.remove('swiper-slide');
                slider.appendChild(card);
            });
            
            // Remove pagination
            const pagination = this.element.querySelector('.as-seen-on-pagination');
            if (pagination) {
                pagination.remove();
            }
            
            this.isInitialized = false;
        }
    }
}

// Initialize all content-cards-noImage sections on page load
document.addEventListener('DOMContentLoaded', function() {
    // Target sections that contain the as-seen-on structure
    const sections = document.querySelectorAll('.as-seen-on-section');
    sections.forEach(section => {
        const instance = new ContentCardsNoImage(section);
        instance.init();
    });
}); 